import { render, staticRenderFns } from "./InviteProspect.vue?vue&type=template&id=11a7cc58&scoped=true&"
import script from "./InviteProspect.vue?vue&type=script&lang=js&"
export * from "./InviteProspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a7cc58",
  null
  
)

export default component.exports